var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilterCategory(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2343_129762",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2343_129762)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.33301 8.688L10 2.604L13.667 8.688H6.33301ZM14.5 17.688C13.6113 17.688 12.858 17.3787 12.24 16.76C11.6213 16.142 11.312 15.3887 11.312 14.5C11.312 13.6113 11.6213 12.858 12.24 12.24C12.858 11.6213 13.6113 11.312 14.5 11.312C15.3887 11.312 16.142 11.6213 16.76 12.24C17.3787 12.858 17.688 13.6113 17.688 14.5C17.688 15.3887 17.3787 16.142 16.76 16.76C16.142 17.3787 15.3887 17.688 14.5 17.688ZM3.31201 17.188V11.812H8.68801V17.188H3.31201ZM14.5 16.604C15.0833 16.604 15.58 16.3993 15.99 15.99C16.3993 15.58 16.604 15.0833 16.604 14.5C16.604 13.9167 16.3993 13.42 15.99 13.01C15.58 12.6007 15.0833 12.396 14.5 12.396C13.9167 12.396 13.42 12.6007 13.01 13.01C12.6007 13.42 12.396 13.9167 12.396 14.5C12.396 15.0833 12.6007 15.58 13.01 15.99C13.42 16.3993 13.9167 16.604 14.5 16.604ZM4.39601 16.104H7.60401V12.896H4.39601V16.104ZM8.25001 7.604H11.75L10 4.729L8.25001 7.604Z",
    fill: "#686B7A"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterCategory);
export default __webpack_public_path__ + "static/media/filter-category.8cf89f967903ff1c620caf4abfafa0ca.svg";
export { ForwardRef as ReactComponent };